<template>
    <div class="pd video-tree">
        <el-form  :model="formData" :rules="formRules" ref="formRef" label-width="80px" size="mini">
            <el-form-item class="form-title"  label="是否启用" >
                <el-radio class="mrl15 mrt5"  v-model="formData.i_state" :label=1 @change="radiodata" :disabled="star">启用</el-radio>
                <el-radio class=" mrt5"  v-model="formData.i_state" :label=0 @change="radiodata" :disabled="unstar">停用</el-radio>
            </el-form-item>
            <el-form-item class="form-title"  label="分组" >
                <el-radio class="mrl15 mrt5"  v-model="formData.i_groupId" :label=1 @change="loopdata" :disabled="over">分组一</el-radio>
                <el-radio class=" mrt5"  v-model="formData.i_groupId" :label=2   @change="loopdata" :disabled="over">信息部</el-radio>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_note" label="设备名称">
                <el-input  v-model="formData.vc_name" :disabled="over" style="width: 70%">
                </el-input>
            </el-form-item>
        </el-form>
        <div slot="footer"  class="dialog-footer" style="text-align: center">
            <el-button type="primary" @click="saveForm" :class="baseerp+'btn'" :disabled="savedata" size="mini">{{$t('button_save')}}</el-button>
            <el-button size="mini" @click="cancel">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import * as API from "../api"
    //import chooseEquipment from "./chooseEquipment";
    //import choosePic from "./choosePic";
    import {baseerp} from "@/utils/baseUrl";
    import Video from "../index";
    export default {
        name: "uploadMaterial",
        components: {Video},
        //components:{chooseEquipment,choosePic},
        props:{
            application:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                star:false,
                unstar:false,
                over:false,
                currentPage:1,
                iD:0,
                i_state:0,
                i_groupId:2,
                formData:{
                    i_state:0,
                    i_groupId:2,
                    vc_name:"",
                },
                /****************/
                savedata:false,
                resourceList:[],
                pic_title:"选择素材",
                pic:{},
                pic_dialogVisible:false,
                scheduleId:"",
                showid:0,
                //isloop:"",
                srcsrc:"",
                inputdialogVisible:false,
                imputval:"",
                srcData:[],
                newarr:[],
                deleteLi: "",
                deleteLidex: "",
                imgList:[],
                videoList:[],
                equipment:{},
                dialogVisible:false,
                title:"",
                addedit:false,
                //shownum:'',
                i_type:"2",
                loop:1,
                draw:0,
                baseerp:"",
                /*********************************/
                edit:false,
                proname:"",
                formRules:{
                    /*gsname:[{required:true,message:"请选择公司",trigger:"change"}],
                    cjname:[{required:true,message:"请选择车间",trigger:"change"}],
                    zdname:[{required:true,message:"请选择制定人",trigger:"change"}],
                    proname:[{required:true,message:"请选择产品",trigger:"change"}],
                    ckname:[{required:true,message:"请选择仓库",trigger:"change"}],
                    jgcost:[{required:true,message:"请输入加工费",trigger:"blur"}],
                    shul:[{required:true,message:"请输入数量",trigger:"blur"}],
                    endtime:[{required:true,message:"请选择结束日期",trigger:"change"}],
                    begintime:[{required:true,message:"请选择开始日期",trigger:"change"}],*/
                },
                companyName:[],
                groupName:[],
                personName:[],
                proList:[],
                warehouseName:[],
                gsid:0,
                ckid:0,
                pzid:0,
                cjid:0,
                i_id:0,
                wtgsid:0,
                zduid:0,
                zdname:"",
                pzname:"",
                wtname:"",
                gsname:"",
                cjname:"",
                lastTime:"",
                disabled:false,
                mid:0,
            }
        },
        watch:{


        },
        mounted() {
            this.baseerp=baseerp;
            //console.log("baseerp",this.baseerp);
            if (this.application){
                //console.log("this.application",this.application);
                this.iD=this.application.value.i_id;
                //this.formData.i_state=this.application.value.i_state;
                this.formData.i_groupId=this.application.value.i_groupId;
                this.formData.vc_name=this.application.value.vc_name;
                //console.log("formdata",this.formData);
                this.currentPage=this.application.currentPage;
                if (this.application.title=="停用"){
                    this.over=true;
                    this.formData.i_state=0;
                    this.star=true;
                }else{
                    this.over=false;
                    this.formData.i_state=1;
                    this.unstar=true;
                }
            }
        },
        computed:{},
        methods: {
            ...mapActions(["getCurrentMenuId"]),


            radiodata(val){
                this.formData.i_state=val;
                //console.log(this.formData.i_state,"this.formData.i_state");
            },

            loopdata(val){
                this.formData.i_groupId=val;
                //console.log(this.formData.i_groupId,"this.formData.i_groupId");
            },



            //updateDevice
            async saveForm(){
                this.savedata=true;
                //console.log(this.formData,"formData");
                let param={
                    vc_name:this.formData.vc_name,
                    i_state:this.formData.i_state,
                    i_groupId:this.formData.i_groupId,
                    i_id:this.iD,
                };
                //console.log("param",param);
                let res=await API.updateDevice(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.savedata=false;
                    this.$emit("close");
                    this.$emit("getDeviceList",this.currentPage);
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },



            cancel(){
                this.$emit('close');
            },

        },
    }
</script>

<style lang="scss" scoped>

    .mrr2{
        margin-right: 2px;
    }

    .flex- {
        display: flex;
        flex-flow: wrap;
        justify-content: flex-start;
        align-items: center;
    }



    .mrr15{
        margin-right: 15px;
    }

    /***********************************/
    .pd{
        min-width: 500px;
    }
    .flex{
        display: flex;
    }
    .item{
        width: 100%;
    }





    /deep/{
        .ghwdiv .el-dialog__header{
            background-color: #3e82e8;
        }


        .havaydiv .el-dialog__header{
            background-color: #e8c984;
        }

        .el-dialog__body{
            word-break:unset;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 6px;
        }
        .el-tabs--border-card > .el-tabs__content{
            height: calc(100% - 60px);
            overflow-y: auto;

        }
    }

    /deep/{

        .input .el-input__inner{
            width: 200px;
        }

        .num{
            margin-bottom: 12px;
        }
        .num .el-form-item__label {
            color: #b3d268;
            font-size: 16px;
            font-style: italic;
        }
        .num .el-form-item__content {
            width: 130px;
        }

        .danger-row{
            color: #999;
        }

    }

    .proItem_info1{
        text-align: left;
        .one-title{
            width: 100px;
            display: inline-block;
            text-align: center;
        }
        /deep/{
            .el-icon-star-on{
                display: inline-block;
                vertical-align:super;
            }

        }
        .zs{
            padding-left: 16px;
            color: #a0a0a0;
        }
        .img-box{
            /*border: 1px solid red;*/
            margin: 10px;
            .uploadPhone{
                width: 70px;
                height: 80px;
                position: relative;
                width: 100%;
                /*border: 1px solid cornflowerblue;*/
            }
            .uploadPhone img{
                width: 70px;
                height: 80px;
            }
            .upload-box{
                /*background: red;*/
                width: 10%;
                height: 100%;
            }
            .upload-input{
                position: absolute;
                opacity: 0;
                width: 100px;
                height: 105px;
            }
        }
        .flex1{
            display: flex;
        }
    }
</style>